import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'nio-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  currentApplicationVersion = environment.appVersion;
  currentYear = new Date().getFullYear();

  constructor() {}
}
